import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-loading-item',
  templateUrl: './plan-loading-item.component.html',
  styleUrls: ['./plan-loading-item.component.scss']
})
export class PlanLoadingItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
